var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 30V26.6667H3.2C2.32 26.6667 1.56667 26.3403 0.94 25.6875C0.313333 25.0347 0 24.25 0 23.3333V3.33333C0 2.41667 0.313333 1.63194 0.94 0.979167C1.56667 0.326389 2.32 0 3.2 0H28.8C29.68 0 30.4333 0.326389 31.06 0.979167C31.6867 1.63194 32 2.41667 32 3.33333V8.33333H28.8V3.33333H3.2V23.3333H28.8V15H17.28L20.24 18.0833L18 20.4167L11.2 13.3333L18 6.25L20.24 8.58333L17.28 11.6667H28.8C29.68 11.6667 30.4333 11.9931 31.06 12.6458C31.6867 13.2986 32 14.0833 32 15V23.3333C32 24.25 31.6867 25.0347 31.06 25.6875C30.4333 26.3403 29.68 26.6667 28.8 26.6667H22.4V30H9.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartIcon);
export default __webpack_public_path__ + "static/media/restart_icon.0f7920343ddaff68539683f66df28736.svg";
export { ForwardRef as ReactComponent };